export default __webpack_public_path__ + "static/media/husqy.0ad13385.png";